<a  [routerLink]="link" [queryParams]="queryParams" [fragment]="anchorFragment"><ng-content></ng-content></a>
